import { Storage } from 'aws-amplify';

/**
 * Utility function to get s3 bucket and path from URI
 */
export const getS3BucketAndPath = (
  uri: string,
): { bucket: string; path: string; uri: string } | undefined => {
  const match = uri.match('s3://([^/]+)/(.*)');
  if (!match) {
    return undefined;
  }
  return { uri: match[0], bucket: match[1], path: match[2] };
};

/**
 * Utility function to initiate download of file/blob
 */
export const downloadBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.setAttribute('href', url);
  a.setAttribute('download', filename);
  a.click();
  URL.revokeObjectURL(url);
  return a;
};

/**
 * This function will return the S3 file
 */
export const getS3File = (
  filePath: string,
  fileName: string,
  bucketName?: string,
) =>
  Storage.get(fileName, {
    ...(bucketName && {
      bucket: bucketName,
      region: 'us-west-2',
    }),
    download: true,
    customPrefix: { public: filePath },
    level: 'public',
    cacheControl: 'no-cache, no-store, must-revalidate',
    expires: 0,
  });

/**
 * This function will retrieve the file from S3 & initiate download.
 */
export const downloadFile = async (
  filePath: string,
  fileName: string,
  bucketName?: string,
  downloadFileName?: string,
) => {
  const result = await getS3File(filePath, fileName, bucketName);
  if (!result.Body) {
    return;
  }

  downloadBlob(result.Body as Blob, downloadFileName || fileName);
};

/**
 * This function downloads a file from an Amazon S3 bucket using the provided S3 URI.
 */
export const downloadS3URI = async (
  s3URI: string,
  downloadFileName?: string,
) => {
  const s3 = getS3BucketAndPath(s3URI ?? '');
  const indexOf = s3?.path?.lastIndexOf('/') ?? -1;
  const filePath = s3?.path?.slice(0, indexOf + 1) ?? '';
  const fileName = s3?.path?.slice(indexOf + 1) ?? '';
  await downloadFile(
    filePath,
    fileName,
    s3?.bucket,
    downloadFileName || fileName,
  );
};
